import { withShadowDOM } from '@updater-legacy/components/custom-element';
import { ENVIRONMENT } from '../../environment';
import styles from './index.properties.css';

class BlueHeader extends withShadowDOM(styles)() {
  constructor() {
    super();
    const slot = document.createElement('slot');
    this.shadowRoot.appendChild(this._styles);
    this.shadowRoot.appendChild(slot);
  }

  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    if (!this.setBackground) {
      this.style.setProperty(
        '--background-image',
        `url(${ENVIRONMENT.endpoints.cloudinary}/v1566239125/background-pattern-light-grey.svg)`
      );
      this.setBackground = true;
    }
  }
}
customElements.define('upd-tiled-header', BlueHeader);
